import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import _ from "lodash";
import { isMobile } from "react-device-detect";
import ServiceStorage from "../../../core/services/service.storage";
import ContextApp from "./../../../core/contexts/context.app";
import ApiRegion from "../../../core/api/api.region";
import ApiAmusementGroup from "../../../core/api/api.amusementGroup";
import {
  Container,
  Row,
  Col,
  Button,
  Accordion,
  Card,
  useAccordionButton,
  AccordionContext,
  Alert,
} from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import { Navigation, Keyboard, Scrollbar } from "swiper/modules";
import TitleH6WithLine from "../../components/TitleH6WithLine";
import SkeletonDetailsContetnt from "../../components/SkeletonComponent/SkeletonDetailsContetnt";
import CardTileH6 from "../../components/CardTileH6";
import SkeletonAmusementGroupTitle from "../../components/SkeletonComponent/SkeletonAmusementGroupTitle";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import LazyLoad from "react-lazyload";
import { IconChevronLeft } from "../../../assets/icons";
import notFound from "../../../assets/images/not-found.svg";
let specialOffer = "";

/*** نمایش قسمت مربوط به سوالات متداول ********************/
function ContextAwareToggle({ children, eventKey, callback }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey)
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <h6
      className={
        isCurrentEventKey
          ? " py-1 mb-0 fs-normal open"
          : "py-1 mb-0 fs-normal  "
      }
      onClick={decoratedOnClick}
    >
      {children}
    </h6>
  );
}
/********************** */
function ListItems(props) {
  const ctx = useContext(ContextApp);
  const [regions, setRegions] = useState([]);
  const { urlParamGroup, urlParamCity } = useParams(); // دریافت پارامتر urlName از روت
  const [loadingAmusementSlider, setLoadingAmusementSlider] = useState(true);
  const [groups, setGroups] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [pageTitle, setPageTitle] = useState("");
  const [pageContent, setPageContent] = useState("");
  const [amusementGroupContent, setAmusementGroupContent] = useState("");
  const list = [1, 2, 3, 4, 5, 6];
  const location = useLocation();
  const navigate = useNavigate();
  const [isHiddenHandIcon, setIsHiddenHandIcon] = useState();

  // ریست کردن موقعیت اسکرول به ابتدای صفحه
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    (async () => {
      const storageCity = ServiceStorage.getCity();
      const cityLis =
        _.has(storageCity, "cityList") && !_.isNil(storageCity.cityList)
          ? JSON.parse(storageCity?.cityList)
          : [];

      let cityListLastUpdateDays = 0;
      let cityListLastUpdate = new Date();
      if (!_.isNil(storageCity?.cityListLastUpdate)) {
        cityListLastUpdate = new Date(storageCity.cityListLastUpdate);
        const now = new Date();
        cityListLastUpdateDays = Math.floor(
          (Date.UTC(now.getFullYear(), now.getMonth(), now.getDate()) -
            Date.UTC(
              cityListLastUpdate.getFullYear(),
              cityListLastUpdate.getMonth(),
              cityListLastUpdate.getDate()
            )) /
            (1000 * 60 * 60 * 24)
        );
      }
      const newUpdateDate =
        cityListLastUpdateDays > 7 ? new Date() : cityListLastUpdate;
      const regoinResult =
        cityLis.length == 0 || cityListLastUpdateDays > 7
          ? await ApiRegion.getRegions()
          : cityLis;
      setRegions(regoinResult);
      const urlSelectedCity = _.find(regoinResult, function (item) {
        return _.lowerCase(item.englishName) === _.lowerCase(urlParamCity);
      });
      // console.log("urlSelectedCity", urlSelectedCity);
      // if (_.lowerCase(urlSelectedCity.englishName) != _.lowerCase(urlParamCity))
      if (_.isNil(urlSelectedCity)) navigate("../PageNotFound");
      setSelectedCity(
        !_.isNil(urlSelectedCity) && !_.isEmpty(urlSelectedCity)
          ? urlSelectedCity
          : ctx.selectedCity
      );
      if (!_.isNil(urlSelectedCity) && _.isObject(urlSelectedCity)) {
        if (urlSelectedCity.selectedCity?.id != ctx?.selectedCity?.id) {
          ctx.setSelectedCity(urlSelectedCity);
        }
      }
      // console.log(
      //   "ServiceStorage urlSelectedCity",
      //   !_.isNil(urlSelectedCity) ? urlSelectedCity : ctx.selectedCity
      // );
      ServiceStorage.setCity({
        cityListLastUpdate: newUpdateDate,
        cityList: regoinResult,
        selectedCity: !_.isNil(urlSelectedCity)
          ? urlSelectedCity
          : ctx.selectedCity,
      });
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (regions.length > 0) {
        if (!_.isNil(selectedCity) && selectedCity.id != ctx.selectedCity.id) {
          await getAmusements();
          setSelectedCity(ctx.selectedCity);
        } else if (_.isNil(groups)) {
          await getAmusements();
        }

        // if (
        //   !_.isEmpty(selectedCity) &&
        //   _.isEmpty(urlParamGroup)
        // ) {
        //   setPageTitle();
        // }
      }
    })();
  }, [ctx.selectedCity, selectedCity]);
  useEffect(() => {
    (async () => {
      if (regions.length > 0) {
        if (!_.isNil(selectedCity)) {
          await getAmusements();
          setSelectedCity(ctx.selectedCity);
        } else if (_.isNil(groups)) {
          await getAmusements();
        }
        // if (
        //   !_.isEmpty(selectedCity) &&
        //   selectedCity?.id == 899 &&
        //   _.isEmpty(urlParamGroup)
        // ) {
        //   setPageTitle(
        //     "لیست تفریحات کیش با تخفیف ویژه 90 درصدی + مشاوره رایگان - تفریحان"
        //   );
        // }
      }
    })();
  }, [urlParamGroup]);
  const getAmusements = async () => {
    try {
      const response = await ApiAmusementGroup.getAmusementGroups({
        title: urlParamGroup,
        city: ctx.selectedCity.id,
      });

      setGroups(response.groups);
      setAmusementGroupContent(response?.pageContent);
      setLoadingAmusementSlider(false);
      setPageContent({
        cityName: response.region.name,
        // title: _.isNil(urlParamGroup)
        //   ? response.region.pageTitle
        //   : response.groups[0].title + " " + response.region.name,
        // metaDesc: _.isNil(urlParamGroup) ? response.region.metaDescription : "",
        title: response?.pageContent?.pageTitle,
        metaDesc: response?.pageContent?.metaDescription,
      });
    } catch (error) {}
  };

  const handleClick = (value) => {};

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // or auto
    });
  };

  /**************************** */
  // State to hold the screen width and height
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [sliderCountItem, setSliderCountItem] = useState("");
  // Effect to update screen size when window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Add event listener on mount
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures this runs only once
  // Function to update viewMode based on screen size
  useEffect(() => {
    if (screenSize.width < 448) {
      setSliderCountItem(1);
    } else if (screenSize.width >= 448 && screenSize.width < 666) {
      setSliderCountItem(2);
    } else if (screenSize.width >= 666 && screenSize.width < 920) {
      setSliderCountItem(3);
    } else if (screenSize.width >= 920 && screenSize.width < 1142) {
      setSliderCountItem(4);
    } else {
      setSliderCountItem(5);
    }
  }, [screenSize]); // Re-run this effect when screenSize changes
  /*** نمایش آیکن دست ******************* */
  // useEffect(() => {
  //   if (groups?.length > 0) {
  //     setIsHiddenHandIcon(new Array(groups.length).fill(false));
  //   }
  // }, [groups]);

  // const handleSlideChange = (swiper, index) => {
  //   const updatedVisibility = [...isHiddenHandIcon];

  //   updatedVisibility[index] = true;
  //   setIsHiddenHandIcon(updatedVisibility);
  // };

  const handleSlideChange = (swiper, index) => {
    setIsHiddenHandIcon(true);
  };
  /************************************ */
  return (
    <>
      <div className="wrapper">
        {/* {console.log("pageContent", pageContent)}
        {console.log(
          "!_.isNil(pageContent)",
          !_.isNil(pageContent) && _.has(pageContent, "title")
        )} */}
        {!_.isNil(pageContent) ? (
          <Helmet>
            <link
              rel="canonical"
              href={window.location.origin + location.pathname}
            ></link>
            <meta
              property="og:url"
              content={window.location.origin + location.pathname}
            />
            <title>{pageContent.title}</title>
            <meta property="og:title" content={pageContent.title} />
            <meta property="og:description" content={pageContent.metaDesc} />
            <meta name="description" content={pageContent.metaDesc} />
          </Helmet>
        ) : (
          ""
        )}
      </div>
      {/* {console.log("groups", groups)} */}
      {isMobile ? (
        //******** حالت موبایل**************************
        <Container fluid="xl" className="pt-3 px-3 margin-bottom-page">
          {/* <div className=" bg-light rounded-pill border py-3">
            <Row className="gx-0">
              <Col className="border-end text-center">
                <IconCategory1 fillColor="#404040" /> دسته بندی
              </Col>
              <Col className="text-center">
                <IconFilter fillColor="#404040" /> فیلترکردن
              </Col>
            </Row>
          </div> */}
          {_.isNil(urlParamGroup) && !_.isNil(amusementGroupContent) && (
            <>
              {!_.isNil(amusementGroupContent.h1) && (
                <h1 className="text-center fs-103">
                  {amusementGroupContent?.h1}
                </h1>
              )}
              {!_.isNil(amusementGroupContent.content) && (
                <div className="text-center  title-group-page mb-0">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: amusementGroupContent?.content,
                    }}
                  />
                </div>
              )}
            </>
          )}

          {loadingAmusementSlider
            ? list.map((item, index) => (
                <>
                  <SkeletonAmusementGroupTitle />
                  <Swiper
                    className="amusement-swiper"
                    spaceBetween={15}
                    slidesPerView={"auto"}
                  >
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                    <SwiperSlide>
                      <SkeletonDetailsContetnt />
                    </SwiperSlide>
                  </Swiper>
                </>
              ))
            : groups?.map((groupItem, index) => (
                <div key={groupItem.id + "_" + groupItem.type}>
                  {_.isNil(urlParamGroup) ? (
                    <TitleH6WithLine
                      titleTag="h2"
                      titleText={
                        groupItem.type == 1
                          ? groupItem.title + " " + pageContent.cityName
                          : groupItem.title
                      }
                    />
                  ) : (
                    <TitleH6WithLine
                      titleTag="h1"
                      titleText={
                        groupItem.type == 1
                          ? groupItem.title + " " + pageContent.cityName
                          : groupItem.title
                      }
                    />
                  )}
                  <div>
                    <div className="swiper-container d-flex align-items-center px-3">
                      <div className="custom-navigation">
                        <button
                          className={`btn-no-style flipX right-arrow-slider shadowsm prev-${index}`}
                        >
                          <IconChevronLeft fillColor="#035b96" />
                        </button>
                      </div>
                      <Swiper
                        onSlideChange={(swiper) =>
                          handleSlideChange(swiper.activeIndex, index)
                        }
                        id={index}
                        modules={[Keyboard, Scrollbar, Navigation]}
                        className="amusement-swiper amusement-swiper-custom-navigation pb-2"
                        spaceBetween={15}
                        slidesPerView={"auto"}
                        lazy={true}
                        navigation={{
                          nextEl: `.next-${index}`,
                          prevEl: `.prev-${index}`,
                        }}
                        keyboard={{
                          enabled: true,
                        }}
                      >
                        {groupItem?.amusementServices?.map(
                          (amusementService) => (
                            <>
                              {/* {amusementService.id == "140" ||
                        amusementService.id == "116"
                          ? (specialOffer = "true")
                          : (specialOffer = "false")} */}
                              <SwiperSlide
                                key={amusementService.id}
                                data-kkk={amusementService.id}
                              >
                                <CardTileH6
                                  itemImgSrc={
                                    process.env.REACT_APP_API_URL +
                                    amusementService.imageUrl
                                  }
                                  amusementUrl={`/details/${amusementService.urlName}`}
                                  amusementName={amusementService.name}
                                  amusementPrice={amusementService.price}
                                  amusementFinalPrice={
                                    amusementService.originalPrice
                                  }
                                  handleClick={handleClick}
                                  hasReserveDetail_V2={
                                    amusementService.hasReserveDetail_V2
                                  }
                                  // specialOffer={specialOffer}
                                />
                              </SwiperSlide>
                            </>
                          )
                        )}
                      </Swiper>
                      <div className="custom-navigation">
                        <button
                          className={`btn-no-style left-arrow-slider shadowsm next-${index}`}
                        >
                          <IconChevronLeft fillColor="#035b96" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div style={{ height: "38px", marginTop: "-5px" }}>
                    {groupItem?.amusementServices?.length > sliderCountItem &&
                    !isHiddenHandIcon ? (
                      <div
                        class="swipe position-relative"
                        // style={{  }}
                      >
                        <div class="hand-icon"></div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}

          {!_.isNil(urlParamGroup) && groups?.length > 0 && (
            <>
              <Link
                to={
                  ctx.selectedCity?.englishName === undefined
                    ? "/c"
                    : `/c/${ctx.selectedCity?.englishName}`
                }
                className=" w-100 "
              >
                <Button
                  variant="outline-dark "
                  className=" w-100  px-4  mb-5 mt-2 "
                  onClick={scrollToTop}
                >
                  <h3 className="fs-09 text-center mb-0 py-2 ">
                    مشاهده تمام تفریحات{" "}
                  </h3>
                </Button>
              </Link>
            </>
          )}
          {groups?.length == 0 && (
            <Container fluid className="bg-light-3   pb-3 rounded-4">
              <Container className="px-0">
                <Row className=" text-small mx-0">
                  <Col xs="12" md="4" className=" pt-4 px-0 text-center">
                    <img src={notFound} alt="خطا" className="w-100" />
                  </Col>
                  <Col className="text-center my-auto">
                    <h2 className="fw-bold fs-103">تفریحی پیدا نشد !</h2>
                    <p className="text-center mt-3 ">
                      هیچ تفریحی برای این دسته در
                      <span className="fw-bold mx-1">
                        {ctx.selectedCity.name}{" "}
                      </span>
                      وجود ندارد.
                    </p>
                    <p>
                      برای مشاهده تمامی تفریحات
                      <span className=""> {ctx.selectedCity.name} </span> روی
                      لینک زیر کلیک کنید
                    </p>
                    <Link
                      to={
                        ctx.selectedCity?.englishName === undefined
                          ? "/c"
                          : `/c/${ctx.selectedCity?.englishName}`
                      }
                      className="  "
                    >
                      <Button
                        variant="primary "
                        className="  px-4  mt-2 "
                        onClick={scrollToTop}
                      >
                        <h3 className="fs-09  mb-0 py-2 rounded-3">
                          مشاهده تمام تفریحات {ctx.selectedCity.name}
                        </h3>
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </Container>
            </Container>
          )}
          {/********** سوالات متداول ***********************/}
          {amusementGroupContent?.questionAnswers != null &&
            amusementGroupContent?.questionAnswers.length > 0 && (
              <Container className="pt-5 pb-3 px-0 ">
                <h3 className="fs-101 fw-bold mb-3">سوالات متداول</h3>
                <Accordion flush className="custom-accordion">
                  {amusementGroupContent?.questionAnswers?.map(
                    (item, index) => (
                      <Card className="rounded-3 mb-2 ">
                        <Card.Body className="py-2">
                          <ContextAwareToggle eventKey={index.toString()}>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: item.questionText,
                              }}
                            />
                          </ContextAwareToggle>
                          <Accordion.Collapse eventKey={index.toString()}>
                            <div
                              className="pt-1"
                              dangerouslySetInnerHTML={{
                                __html: item.answerText,
                              }}
                            />
                          </Accordion.Collapse>
                        </Card.Body>
                      </Card>
                    )
                  )}
                </Accordion>
              </Container>
            )}
        </Container>
      ) : (
        //******** حالت دسکتاپ**************************

        <>
          {_.isNil(urlParamGroup) && !_.isNil(amusementGroupContent) && (
            <Container fluid className="bg-light-3 pt-1">
              <Container fluid="lg" className="border-bottom py-4 text-primary">
                <div className="d-flex align-items-center justify-content-center">
                  {!_.isNil(amusementGroupContent.h1) && (
                    <h1 className="text-center mb-0 fs-102">
                      {amusementGroupContent?.h1}
                    </h1>
                  )}
                  {!_.isNil(amusementGroupContent.content) && (
                    <>
                      <span className="px-2">-</span>
                      <div className="text-center title-group-page  fs-09">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: amusementGroupContent?.content,
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </Container>
            </Container>
          )}
          {loadingAmusementSlider
            ? list.map((item, index) => (
                <Container key={index} fluid className="bg-light-3">
                  <Container fluid="lg" className="pb-2">
                    <div className=" pt-5 mb-2">
                      <SkeletonAmusementGroupTitle />
                      <Swiper
                        className="amusement-swiper"
                        spaceBetween={15}
                        slidesPerView={"auto"}
                      >
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                        <SwiperSlide>
                          <SkeletonDetailsContetnt />
                        </SwiperSlide>
                      </Swiper>
                    </div>
                  </Container>
                </Container>
              ))
            : groups?.map((groupItem, index) => (
                <Container
                  key={groupItem.id + "_" + groupItem.type}
                  fluid
                  className="bg-light-3"
                >
                  <Container fluid="lg" className="pb-2">
                    <div className="d-flex justify-content-between pt-4 px-3 mb-2">
                      {/* <img src="" alt="" /> */}
                      {_.isNil(urlParamGroup) ? (
                        <h2 className="text-start fw-bold text-primary fs-101 my-auto">
                          {groupItem.type == 1
                            ? groupItem.title + " " + pageContent.cityName
                            : groupItem.title}
                        </h2>
                      ) : (
                        <h1 className="text-start fw-bold text-primary fs-101 my-auto">
                          {groupItem.type == 1
                            ? groupItem.title + " " + pageContent.cityName
                            : groupItem.title}
                        </h1>
                      )}
                      <hr className="border-bottom" />
                      <div className="my-auto"></div>
                    </div>
                    <div>
                      <div className="swiper-container d-flex align-items-center px-3">
                        <div className="custom-navigation">
                          <button
                            className={`btn-no-style flipX right-arrow-slider shadow-sm prev-${index}`}
                          >
                            <IconChevronLeft fillColor="#000" />
                          </button>
                        </div>
                        <Swiper
                          onSlideChange={(swiper) =>
                            handleSlideChange(swiper.activeIndex, index)
                          }
                          id={index}
                          modules={[Keyboard, Scrollbar, Navigation]}
                          className="amusement-swiper amusement-swiper-custom-navigation pb-2"
                          spaceBetween={8}
                          slidesPerView={"auto"}
                          lazy={true}
                          navigation={{
                            nextEl: `.next-${index}`,
                            prevEl: `.prev-${index}`,
                          }}
                          keyboard={{
                            enabled: true,
                          }}
                        >
                          {groupItem?.amusementServices?.map(
                            (amusementService) => (
                              <>
                                {/* {amusementService.id == 140 ||
                          amusementService.id == 116
                            ? (specialOffer = "true")
                            : (specialOffer = "false")} */}
                                <SwiperSlide key={amusementService.id}>
                                  <CardTileH6
                                    itemImgSrc={
                                      process.env.REACT_APP_API_URL +
                                      amusementService.imageUrl
                                    }
                                    amusementUrl={`/details/${amusementService.urlName}`}
                                    amusementName={amusementService.name}
                                    amusementPrice={amusementService.price}
                                    amusementFinalPrice={
                                      amusementService.originalPrice
                                    }
                                    handleClick={handleClick}
                                    hasReserveDetail_V2={
                                      amusementService.hasReserveDetail_V2
                                    }
                                    // specialOffer={specialOffer}
                                  />
                                </SwiperSlide>
                              </>
                            )
                          )}
                        </Swiper>
                        <div className="custom-navigation">
                          <button
                            className={`btn-no-style left-arrow-slider shadow-sm next-${index}`}
                          >
                            <IconChevronLeft fillColor="#000" />
                          </button>
                        </div>
                        <div className="custom-navigation"></div>
                      </div>
                    </div>

                    {/* {groupItem?.amusementServices?.length > sliderCountItem &&
                    !isHiddenHandIcon ? (
                      <div
                        class="swipe position-relative"
                        style={{ marginTop: "-5px" }}
                      >
                        <div class="hand-icon"></div>
                      </div>
                    ) : (
                      <div style={{ height: "30px", width: "150px" }}></div>
                    )} */}
                  </Container>
                  <Container className="text-center">
                    {!_.isNil(urlParamGroup) && (
                      <>
                        <Link
                          to={
                            ctx.selectedCity?.englishName === undefined
                              ? "/c"
                              : `/c/${ctx.selectedCity?.englishName}`
                          }
                          className=" w-100 "
                        >
                          <Button
                            variant="outline-danger "
                            className=" px-5  mb-5 mt-4 "
                            onClick={scrollToTop}
                          >
                            <h3 className="fs-09 text-center mb-0 py-2 ">
                              مشاهده تمام تفریحات{" "}
                            </h3>
                          </Button>
                        </Link>
                      </>
                    )}
                  </Container>
                </Container>
              ))}

          {/***************************/}
          {groups?.length == 0 && (
            <Container fluid className="bg-light-3 pt-4 pb-3">
              <Container className="">
                <Row className=" text-small mx-0">
                  <Col xs="12" md="4" className=" pt-4 px-0 text-center">
                    <img src={notFound} alt="خطا" className="w-100" />
                  </Col>
                  <Col className="text-center my-auto">
                    <h2 className="fw-bold fs-103">تفریحی پیدا نشد !</h2>
                    <p className="text-center mt-3 ">
                      هیچ تفریحی برای این دسته در
                      <span className="fw-bold mx-1">
                        {ctx.selectedCity.name}{" "}
                      </span>
                      وجود ندارد.
                    </p>
                    <p>
                      برای مشاهده تمامی تفریحات
                      <span className=""> {ctx.selectedCity.name} </span> روی
                      لینک زیر کلیک کنید
                    </p>
                    <Link
                      to={
                        ctx.selectedCity?.englishName === undefined
                          ? "/c"
                          : `/c/${ctx.selectedCity?.englishName}`
                      }
                      className="  "
                    >
                      <Button
                        variant="primary "
                        className="  px-4  mt-2 "
                        onClick={scrollToTop}
                      >
                        <h3 className="fs-09  mb-0 py-2 rounded-3">
                          مشاهده تمام تفریحات {ctx.selectedCity.name}
                        </h3>
                      </Button>
                    </Link>
                  </Col>
                </Row>
              </Container>
            </Container>
          )}

          {/********** سوالات متداول ***********************/}

          {amusementGroupContent?.questionAnswers &&
            amusementGroupContent?.questionAnswers.length > 0 && (
              <Container fluid className="bg-light-3 pt-4 pb-3">
                <Container>
                  <h3 className="fs-101 fw-bold mb-3">سوالات متداول</h3>
                  <Accordion flush className="custom-accordion">
                    {amusementGroupContent?.questionAnswers?.map(
                      (item, index) => (
                        <Card className="rounded-3 mb-2 ">
                          <Card.Body className="py-2">
                            <ContextAwareToggle eventKey={index.toString()}>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: item.questionText,
                                }}
                              />
                            </ContextAwareToggle>
                            <Accordion.Collapse eventKey={index.toString()}>
                              <div
                                className="pt-1"
                                dangerouslySetInnerHTML={{
                                  __html: item.answerText,
                                }}
                              />
                            </Accordion.Collapse>
                          </Card.Body>
                        </Card>
                      )
                    )}
                  </Accordion>
                </Container>
              </Container>
            )}
        </>
      )}
    </>
  );
}
export default ListItems;
